var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityfirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bb40a71f-1ba8-46c0-b464-e8f1a251e6c1",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 339.8222 508.7385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b4930235-413a-4561-8931-62b85971e21b",
    x1: 127.9078,
    y1: 1156.9223,
    x2: 127.9078,
    y2: 952.9877,
    gradientTransform: "translate(-80.1778 -681)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe380",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ffe07a",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ffd969",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#ffcd4d",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#ffbd28",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#ffab00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f69aeb07-046f-4333-8102-b2ea857bce4a",
    x1: 246.0163,
    y1: 1145.4839,
    x2: 246.0163,
    y2: 825.7934,
    gradientTransform: "translate(-80.1778 -681)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c7e5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00c7e5",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#00c7e5",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00c7e5",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#00c7e5",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#00c7e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fcf3723d-9d8e-4879-93cb-3f676533d469",
    x1: 372.27,
    y1: 1189.7385,
    x2: 372.27,
    y2: 892.6659,
    gradientTransform: "translate(-80.1778 -681)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2684ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#2380f9",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1c75ea",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1062d2",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#0049b1",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#0049b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b12f1150-4ecd-4b3a-9b67-8e847786f82b",
    x1: 194.0716,
    y1: 320.8583,
    x2: 278.8236,
    y2: 432.6872,
    gradientTransform: "matrix(1, 0, 0, -1, -1.56, 490.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c9aff"
  })))), /*#__PURE__*/React.createElement("rect", {
    y: 271.9877,
    width: 95.46,
    height: 203.9346,
    rx: 3.7267,
    style: {
      opacity: 0.6000000238418579,
      isolation: "isolate",
      fill: "url(#b4930235-413a-4561-8931-62b85971e21b)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.1084,
    y: 144.7934,
    width: 95.46,
    height: 319.6905,
    rx: 4.5867,
    style: {
      opacity: 0.6000000238418579,
      isolation: "isolate",
      fill: "url(#f69aeb07-046f-4333-8102-b2ea857bce4a)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.3622,
    y: 211.6659,
    width: 95.46,
    height: 297.0726,
    rx: 3.7267,
    style: {
      fill: "url(#fcf3723d-9d8e-4879-93cb-3f676533d469)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.9709,30C228.5724,30,211.4,49.997,169.4852,59.393a7.3057,7.3057,0,0,0-5.6489,7.2682c1.8829,80.1576,40.39,131.2046,82.1911,155.2688,41.7452-24.1019,80.2517-75.1112,82.1347-155.2688a7.3059,7.3059,0,0,0-5.6489-7.2682C280.5985,49.9782,263.4259,30,246.0274,30Z",
    transform: "translate(-80.1778 -30)",
    style: {
      fill: "#c1c7d0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.9709,38.21c5.9313,0,13.1807,3.7659,22.37,8.7181,11.9191,6.3267,28.2444,15.0637,51.5742,20.3171-.9415,35.6068-9.4148,67.2028-24.968,93.922a148.3771,148.3771,0,0,1-48.957,51.16,148.3777,148.3777,0,0,1-48.9569-51.16c-15.6474-26.7192-24.0454-58.3717-24.9681-93.922,23.3676-5.3476,39.6551-13.99,51.5743-20.3171,9.1889-4.8769,16.4383-8.7181,22.37-8.7181",
    transform: "translate(-80.1778 -30)",
    style: {
      fill: "url(#b12f1150-4ecd-4b3a-9b67-8e847786f82b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.0026,106.5423,274.9119,95.4517a1.5627,1.5627,0,0,0-2.203,0L239.663,128.1586,224.43,113.8293a1.563,1.563,0,0,0-2.1654,0L211.1738,124.92a1.5628,1.5628,0,0,0-.0117,2.21l.0117.0117L238.59,153.5033a1.5628,1.5628,0,0,0,2.1842,0l45.1911-44.9274a1.5629,1.5629,0,0,0,0-2.2031Z",
    transform: "translate(-80.1778 -30)",
    style: {
      fill: "#ffc400"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityfirst);
export default __webpack_public_path__ + "static/media/securityfirst.10628f3f47425c253f09ea21fcfe7f91.svg";
export { ForwardRef as ReactComponent };